import type { BrandConfig } from './types';

export const visionfirm: BrandConfig = {
  key: 'visionfirm',
  name: '',
  appTitle: 'VisionFirm Intelligence Hub',
  appSubtitle: 'Intelligence Hub',

  colors: {
    // Midnight — anchor brand color (replaces the previous orange primary)
    primary: {
      50: '#f3f5f8',
      100: '#e2e7ee',
      200: '#c0cbd9',
      300: '#94a3bd',
      400: '#5b7193',
      500: '#0F1B2D',
      600: '#0c1525',
      700: '#08101c',
      800: '#050a13',
      900: '#020409',
      950: '#010205',
    },
    // Steel — cool grey chrome (Gray Subtle → Steel Light → Steel Medium → Steel)
    secondary: {
      50: '#f4f6f8',
      100: '#E8EBEF',
      200: '#C2CBD5',
      300: '#a1adba',
      400: '#7A8A9D',
      500: '#5d6e82',
      600: '#3C4F66',
      700: '#2f3e51',
      800: '#222c3a',
      900: '#151b25',
      950: '#0a0e13',
    },
    // Cobalt — vivid blue accent for CTAs and links
    accent: {
      50: '#eef2ff',
      100: '#dde5ff',
      200: '#b9c8ff',
      300: '#92a8ff',
      400: '#5a7eff',
      500: '#2E5BFF',
      600: '#1f47e0',
      700: '#1937b8',
      800: '#152a8c',
      900: '#0f1f66',
      950: '#0a1240',
    },
    danger: {
      50: '#fef2f2',
      100: '#fee2e2',
      200: '#fecaca',
      300: '#fca5a5',
      400: '#f87171',
      500: '#ef4444',
      600: '#dc2626',
      700: '#b91c1c',
      800: '#991b1b',
      900: '#7f1d1d',
      950: '#450a0a',
    },
    warning: {
      50: '#fffbeb',
      100: '#fef3c7',
      200: '#fde68a',
      300: '#fcd34d',
      400: '#fbbf24',
      500: '#f59e0b',
      600: '#d97706',
      700: '#b45309',
      800: '#92400e',
      900: '#78350f',
      950: '#451a03',
    },
    success: {
      50: '#f0fdf4',
      100: '#dcfce7',
      200: '#bbf7d0',
      300: '#86efac',
      400: '#4ade80',
      500: '#22c55e',
      600: '#16a34a',
      700: '#15803d',
      800: '#166534',
      900: '#14532d',
      950: '#052e16',
    },
  },

  fonts: {
    sans: ['Albert Sans', 'system-ui', 'sans-serif'],
    mono: ['JetBrains Mono', 'Consolas', 'monospace'],
  },

  fontImports: [
    'https://fonts.googleapis.com/css2?family=Albert+Sans:wght@300;400;500;600;700;800&display=swap',
    'https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;500;600&display=swap',
  ],

  assets: {
    logo: 'brands/visionfirm/logo.png',
    favicon: 'brands/visionfirm/favicon.png',
  },

  // Pulls Vivid Orange and Manilla into the chart rotation so the styleguide
  // palette stays usable even though they aren't dedicated UI roles.
  chartColors: [
    '#0F1B2D', // Midnight (Primary)
    '#2E5BFF', // Cobalt (Accent)
    '#E07A4B', // Vivid Orange
    '#3C4F66', // Steel
    '#D8C9A3', // Manilla
    '#EF4444', // Red (Danger)
    '#22c55e', // Green (Success)
    '#7A8A9D', // Steel Medium
    '#EFE5C9', // Manilla Light
    '#C2CBD5', // Steel Light
  ],
};
